import { render } from "./CookieConsentBanner.vue?vue&type=template&id=de8d4b9e&scoped=true"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=de8d4b9e&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8d4b9e"]])

export default __exports__